module.exports = __webpack_public_path__ + "static/teaser-26c289a38ad3a78da6b82f81d2c0e234.png";